import {
  roleSelectOptions,
  statementEventTypeHeadOptions,
  statementEventTypeOptions,
} from '../../utils/enum-select';

export const useRegistryLogFiltersOptions = () => {
  return {
    roleSelectOptions,
    statementEventTypeOptions,
    statementEventTypeHeadOptions,
  };
};
